import { render, staticRenderFns } from "./CompanyServices.vue?vue&type=template&id=24181a4c&scoped=true"
import script from "./CompanyServices.vue?vue&type=script&lang=js"
export * from "./CompanyServices.vue?vue&type=script&lang=js"
import style0 from "./CompanyServices.vue?vue&type=style&index=0&id=24181a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24181a4c",
  null
  
)

export default component.exports